import React, { useState, useEffect } from 'react'
import { detectLocalTz } from '../../lib/availability'

interface TimezoneSelectProps {
  value: string
  onChange: (timezone: string) => void
  className?: string
}

const COMMON_TIMEZONES = [
  { value: 'Europe/Amsterdam', label: 'Amsterdam (CET/CEST)' },
  { value: 'Europe/London', label: 'London (GMT/BST)' },
  { value: 'Europe/Paris', label: 'Paris (CET/CEST)' },
  { value: 'Europe/Berlin', label: 'Berlin (CET/CEST)' },
  { value: 'America/New_York', label: 'New York (EST/EDT)' },
  { value: 'America/Los_Angeles', label: 'Los Angeles (PST/PDT)' },
  { value: 'Asia/Tokyo', label: 'Tokyo (JST)' },
  { value: 'Australia/Sydney', label: 'Sydney (AEST/AEDT)' }
]

export default function TimezoneSelect({ value, onChange, className = '' }: TimezoneSelectProps) {
  const [searchTerm, setSearchTerm] = useState('')
  const [detectedTz, setDetectedTz] = useState<string>('')

  useEffect(() => {
    const detected = detectLocalTz()
    setDetectedTz(detected)
    if (!value) {
      onChange(detected)
    }
  }, [value, onChange])

  const filteredTimezones = COMMON_TIMEZONES.filter(tz =>
    tz.label.toLowerCase().includes(searchTerm.toLowerCase()) ||
    tz.value.toLowerCase().includes(searchTerm.toLowerCase())
  )

  return (
    <div className={`space-y-2 ${className}`}>
      <label className="block text-sm font-medium text-gray-700">
        🌍 Tijdzone
      </label>
      
      {detectedTz && (
        <div className="text-xs text-gray-500 mb-2">
          Gedetecteerd: {detectedTz}
        </div>
      )}
      
      <div className="relative">
        <input
          type="text"
          placeholder="Zoek tijdzone..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 mb-2"
        />
        
        <select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          {filteredTimezones.map(tz => (
            <option key={tz.value} value={tz.value}>
              {tz.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  )
}
